import { wrapInput } from '@danderson00/react-forms'
import { Body, Box, Help, HoverTooltip, Switch } from '../widgets'

export const Boolean = wrapInput(
  ({ name, checked, onChange, title, toolTip }) => (
    <Box fullWidth justifyContent="space-between">
      <Box gap={8} alignItems="center">
        <Body weight={600}>{title}</Body>
        {toolTip && (
          <HoverTooltip text={toolTip}>
            <Help />
          </HoverTooltip>
        )}
      </Box>
      <Switch name={name} checked={checked} onChange={onChange} />
    </Box>
  ),
  {
    type: 'checkbox',
    valueFromEvent: x => x
  }
)